import { PagesRoutingModule } from './../../../pages/pages-routing.module';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Desarrollado por <b><a href="https://www.smartrural.net" target="_blank">SmartRural</a></b> 2020</span>

  `,
})
export class FooterComponent implements OnInit{

  ngOnInit() {
    console.log("Se inicializa el pie");
  }
}
